import { customTooltip } from './customTooltip'

export const DefaultChartOptions = (data) => {
  // To adjust top of the graph with the max y-data point.
  let combinedDataPoints = []
  data.datasets.forEach(
    ({ data }) => (combinedDataPoints = [...data, ...combinedDataPoints])
  )
  return {
    responsive: true,
    maintainAspectRatio: false,
    showLines: true,
    layout: { padding: { right: 10, top: 10, bottom: -9 } },
    legend: {
      display: false,
    },
    events: ['mousemove'],
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },
    animation: {
      duration: 0,
    },
    scales: {
      yAxes: [
        {
          id: 'y-axis-0',
          display: false,
          gridLines: {
            display: false,
            lineWidth: 1,
            color: 'rgba(0,0,0,0.85)',
          },
          ticks: {
            max: Math.max(...combinedDataPoints) + 10,
            mirror: true,
            fontColor: 'rgba(0,0,0,0.8)',
          },
        },
      ],
      xAxes: [
        {
          id: 'x-axis-0',
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      enabled: false,
      mode: 'index',
      intersect: false,
      // HERE COME THE CUSTOM TOOLTIPS
      custom: function(tooltipModel) {
        customTooltip(tooltipModel, data)
      },
    },
  }
}
